{
    "ENERIX_CONTROL": {
        "LEGEND_DESCRIPTION": "Legend operating status"
    }
}
